// extracted by mini-css-extract-plugin
export default {"root":"IconDollarBag_root__2LXL+"};